import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Modals } from "../Model/Modal/Modals";

import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface GetModalstUseCase {
  invoke: (page: number, pageSize: number, search: string) => Promise<PaginationResult<Modals>>;
}

export class GetModals implements GetModalstUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(page: number, pageSize: number, search: string){
    const getData = this.Repo.getModals(page, pageSize, search);
    return getData;
  }
}